import { Injectable } from '@angular/core';
import { BaseApiService, Result } from '@shared/data-access';
import { map, Observable } from 'rxjs';
import { Tenant, TenantResponse } from '../models/tenant.models';

@Injectable({
  providedIn: 'root',
})
export class TenantApiService {
  constructor(protected api: BaseApiService) {}

  getAllTenants(): Observable<Tenant[]> {
    return this.api
      .get<Result<TenantResponse[]>>('api/tenants')
      .pipe(map((tenants) => tenants.value.map((x) => new Tenant(x.hashId, x.name)).sort((a, b) => a.name.localeCompare(b.name))));
  }
}
